import { Box, styled, ListItemIcon } from '../../../../base';

export const LogoContainer = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2),
    textAlign: 'center',
    borderBottom: `1px solid ${theme.palette.divider}`,
    display: 'flex',
    justifyContent: 'center',
}));

export const StyledLogo = styled('img')({
    maxWidth: '80%',
    height: 'auto',
});

export const StyledListItemIcon = styled(ListItemIcon)({
    minWidth: '40px',
});
